import { addStyles } from 'ethcss'
import { IStyles } from '../../../theme'

const deviceSettingsRemoteControlStyles: IStyles = {
    content: {
        width: '60%',
        marginTop: 14,
    },
    switchWrapper: {
        display: 'flex',
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    field: {
        width: '60%',
        marginTop: 21,
    },
}

addStyles(deviceSettingsRemoteControlStyles)
export default deviceSettingsRemoteControlStyles
